import { useState } from 'react';

import type { Swiper as SwiperClass } from 'swiper/types';

const useSliderEdges = () => {
  const [isAtBeginning, setIsAtBeginning] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);

  const updateEdges = (swiper: SwiperClass) => {
    setIsAtBeginning(swiper.isBeginning);
    setIsAtEnd(swiper.isEnd);
  };

  return { isAtBeginning, isAtEnd, updateEdges };
};

export default useSliderEdges;
